<form [formGroup]="form">
  <div class="steppeur-creer-component">
    <h2 *ngIf="indexPage > 0.4">{{formFullName}}</h2>
    <div class="stepper-loading" *ngIf="update && !isAvisDataReady" role="status" aria-live="polite">
      <span class="spinner-border mr-2" aria-hidden="true"></span>
      {{ 'general.chargement_en_cours' | translate }}
    </div>
    <div class="steppeur " [hidden]="update && !isAvisDataReady">
      <div class="row">
        <div class="col-md-3 fixed-column">
          <div class="bs-stepper vertical poistion-fixed">
            <div class="bs-stepper-header">
              <nav role="group" aria-label="Naviguer sur les étapes">
                <ol class="stepper-ol" id="left-menu-stepper">
                  <li class="stepper-li" *ngFor="let step of stepper; let i = index"
                    [class.disabled]="disableStep(i) || disableIfErrorInSection()"
                    [attr.aria-current]="getStepStatus(i) === 'EtapeCourante' ? 'step' : null"
                    [attr.aria-disabled]="isStepAriaDisabled(i) ? 'true' : null"
                    [attr.aria-label]="getStepAriaLabel(i, (step.libelle | translate))">
                    <div class="stepper-container">
                      <a (click)="goTo(i)"
                        [attr.aria-disabled]="isStepAriaDisabled(i) ? 'true' : null"
                        [attr.aria-label]="getStepAriaLabel(i, (step.libelle | translate))"
                        [attr.title]="'Naviguer à l\'étape ' + i + ' (' + getStepStatusLabel(i) + '): ' + (step.libelle | translate)">
                        <span class="EtapeStepper-Num {{getStepStatus(i)}}" aria-hidden="true">
                          {{i}}
                        </span>
                        <span class="EtapeStepper-Texte" [attr.data-name]="step.libelle" [attr.data-code]="step.id"
                          [attr.data-stepid]="step.prefix"
                          [attr.title]="(step.libelle | translate) + (getStepIndexIfRepeatable(i) || '')">{{step.libelle
                          |translate}}{{getStepIndexIfRepeatable(i)}}{{getFullNameSection(i,step.libelle)}}
                        </span>
                      </a>
                      <mat-icon aria-hidden="true" *ngIf="step.sections !== undefined && step.sections.length>0"
                        (click)="step.required = !step.required">{{upOrDown(step.required)}}</mat-icon>
                      <ng-container *ngIf="isOnError(step)">
                        <div class="stepper-icon-wrapper">
                          <i class="rcn-icon rcn-icon-mdi-error redIcon"
                            aria-hidden="true"
                            [attr.aria-labelledby]="'stepper-error-label-' + i"
                            [matTooltip]="'Section non complétée'">
                          </i>
                          <span [id]="'stepper-error-label-' + i" class="rcn-sr-only">Cette étape comporte des erreurs</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="isOnWarning(step)">
                        <div class="stepper-icon-wrapper">
                          <i class="rcn-icon rcn-icon-mdi-warning yellowIcon"
                            aria-hidden="true"
                            [attr.aria-labelledby]="'stepper-warning-label-' + i"
                            [matTooltip]="'Section soumise à alerte'">
                          </i>
                          <span [id]="'stepper-warning-label-' + i" class="rcn-sr-only">Cette étape comporte des alertes</span>
                        </div>
                      </ng-container>
                    </div>
                    <div class="div_add_section">
                      <button [id]="'id_add_section2_' + i" class="btn-add-section btn btn-outline-primary"
                        *ngIf="isStepRepeatable(i)" (click)="newStep(i)" [disabled]="disableIfErrorInSection() || indexPage < 1">
                        <mat-icon>add</mat-icon>
                        <span>{{'eform-editable.sub-section|add' | translate}}</span>
                      </button>
                      <button *ngIf="isDuplicatedStep(i)" class="btn-delete-section btn btn-outline-primary"
                        (click)="deleteStep(i, step)" [disabled]="disableIfErrorInSection() || indexPage < 1">
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </div>
                    <div *ngIf="step.required" id="left-menu-sous-step">
                      <ol class="sous-etapes stepper-ol" role="group" *ngFor="let section of step.sections; let j = index">
                        <li class="stepper-li"
                          [attr.disabled]="isSubStepDisabled(i) ? true : null"
                          [attr.aria-disabled]="isSubStepDisabled(i) ? 'true' : null"
                          [attr.aria-current]="getSubStepIndicator(i, j+1) === 'encours' ? 'step' : null"
                          [attr.aria-label]="getSubStepAriaLabel(i, j+1, (section.intitule | translate))">
                          <a (click)="goToSection(i,j)"
                            [attr.aria-disabled]="isSubStepDisabled(i) ? 'true' : null"
                            [attr.aria-label]="getSubStepAriaLabel(i, j+1, (section.intitule | translate))">
                            <span class="ss-etp indicateur-{{getSubStepIndicator(i,j+1)}}" aria-hidden="true"></span>
                            <span class="ss-etp-texte" [class.disabled]="i===0"
                              [class.active]="getSubStepIndicator(i,j+1) === 'encours'"
                              [attr.data-name]="section.intitule" [attr.data-code]="section.code"
                              [attr.data-stepid]="section.prefix"
                              [attr.title]="i + '.' + (j + 1) + ' ' + (section.intitule | translate)">
                              {{i}}.{{j + 1}} {{section.intitule |translate}}
                            </span>
                            <ng-container *ngIf="isOnError(step,j)">
                              <div class="stepper-icon-wrapper">
                                <i class="rcn-icon rcn-icon-mdi-error redIcon"
                                  aria-hidden="true"
                                  [attr.aria-labelledby]="'stepper-sub-error-label-' + i + '-' + j"
                                  [matTooltip]="'Section non complétée'">
                                </i>
                                <span [id]="'stepper-sub-error-label-' + i + '-' + j" class="rcn-sr-only">Cette étape comporte des erreurs</span>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="isOnWarning(step,j)">
                              <div class="stepper-icon-wrapper">
                                <i class="rcn-icon rcn-icon-mdi-warning yellowIcon"
                                  aria-hidden="true"
                                  [attr.aria-labelledby]="'stepper-sub-warning-label-' + i + '-' + j"
                                  [matTooltip]="'Section soumise à alerte'">
                                </i>
                                <span [id]="'stepper-sub-warning-label-' + i + '-' + j" class="rcn-sr-only">Cette étape comporte des alertes</span>
                              </div>
                            </ng-container>
                          </a>
                        </li>
                      </ol>
                    </div>
                  </li>
                </ol>
              </nav>
              <div class="save-validate"
                *ngIf="indexPage !== 0.1 && indexPage!== 0.2 && indexPage!==0.3 && indexPage!== 0.4">
                <button (click)="saveFormAndExit(indexPage)" [disabled]="disableIfErrorInSection()" id="id_save" class="btn btn-outline-primary">
                  {{ steppeurMessage.boutonEnregistrer | translate }}
                </button>
                <button *ngIf="isEform" id="id_envoyer" (click)="validateStep(indexPage, true, false)" class="btn btn-primary">
                  {{ steppeurMessage.boutonValiderForm | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="steppeur-formulaire col-md-9" style="padding-bottom:5em">

          <!-- Partie fixe -->
          <app-stepper-introduction [hidden]="indexPage !== 0.1"></app-stepper-introduction>

          <!-- Partie fixe -->
          <app-stepper-choix-formulaire [defaultCritereBhs]="defaultCritereBhs" [form]="form"
            [hidden]="indexPage !== 0.2" [currentFormOnUpdate]="currentFormOnUpdate" [currentJson]="currentJson">
          </app-stepper-choix-formulaire>
          <!-- Partie fixe -->
          <app-stepper-choix-support *ngIf="showDiff" [form]="form" [checkedDiffuseurs]="selectedDiffuseurs"
            [visibleDiffuseurs]="enabledDiffuseurs" [hidden]="indexPage !== 0.3"></app-stepper-choix-support>
          <!-- Partie fixe -->
          <app-stepper-valider-elements [hidden]="indexPage !== 0.4" [indexPage]="indexPage" [form]="form"
            [formulaireIntitule]="formulaireIntitule"></app-stepper-valider-elements>

          <!-- Partie dynamique -->
          <app-form-step id="form-step" *ngIf="formulaireName !== undefined" [disabled]="disabled"
            [formulaireName]="formulaireName" [indexPage]="indexPage" [form]="form" [fadIndex]="fadIndex"
            [referenceAvis]="referenceAvis" [currentJson]="currentJson" [linkForRouter]="linkForRouter"
            [nbDiffuseur]="diffuseurAD" [validationIndex]="getValidationIndex()">
          </app-form-step>
          <!-- Partie fixe -->
          <div class="col-md-10" *ngIf="facturationDila"
            [hidden]="(indexPage !== facturationIndex) || facturationIndex === 0.1">
            <div class="sticky-top fixedtop">
              <app-form-errors [stepid]="'_STEP_ID_SepSep_TypeFacturation'"
                *ngIf="getIsCheckValid('_STEP_ID_SepSep_TypeFacturation')">
              </app-form-errors>
            </div>
            <div [class]="formClass">
              <fieldset id="form-step-facturation">
                <legend id="titre-facturation">
                  {{ 'stepper.form.commun.facturation' | translate }}
                  <div class="star-container">
                    <app-star-preference class="ml-1"
                                         [preferenceType]="preferenceTypeFacturation"
                                         (preferenceSelected)="onFacturationPreferenceSelected($event)">
                    </app-star-preference>
                  </div>
                </legend>
                <app-type-facturation [parentForm]="form" [facturation]="facturationDila" [indexPage]='indexPage'>
                </app-type-facturation>
              </fieldset>
            </div>
          </div>

          <!-- Partie fixe -->
          <div class="col-md-10" *ngIf="indexation"
            [hidden]="(indexPage !== indexationIndex) || indexationIndex === 0.2">
            <div class="sticky-top fixedtop">
              <app-form-errors [stepid]="'_STEP_ID_SepSep_TypeIndexation'"
                *ngIf="getIsCheckValid('_STEP_ID_SepSep_TypeIndexation')">
              </app-form-errors>
            </div>
            <div [class]="formClass">
              <fieldset id="form-step-indexation">
                <legend id="titre-indexation">{{ 'stepper.form.commun.indexation' | translate }}</legend>
                <app-type-indexation [parentForm]="form" [indexation]="indexation" [indexPage]='indexPage' [refAvisLie]="refAvisLie">
                </app-type-indexation>
              </fieldset>
            </div>
          </div>

          <!-- Partie fixe -->
          <fieldset id="form-step-annonceur" class="border-0 p-0 m-0">
            <!-- PRB0053741: fieldset et legend sont utiles pour la génération du pdf -->
            <legend id="titre-id-annonceur" hidden="true">{{ 'stepper.form.commun.idAnnonceur' | translate }}</legend>
            <app-id-annonceur [form]="form" [indexPage]="indexPage" [facturation]="facturation"
                              [isBOAMPorJOUE]="isBOAMPorJOUE" [isSHALorPS]="isSHALorPS" *ngIf="facturation"
                              [hidden]="indexPage !== annonceurIndex"></app-id-annonceur>
          </fieldset>

          <!-- Partie fixe -->
          <app-stepper-valider-demande [onModification]="onModification" [referenceAvis]="referenceAvis"
            [avisId]="avisId" [critereId]="critereId" [form]="form" [hidden]="indexPage !== validationIndex"
            [formulaireIntitule]="formulaireIntitule" [formulaireCategory]="formulaireCategory">
          </app-stepper-valider-demande>

          <div class="footer-buttons col-md-8">
            <button (click)="suivant()" class="btn btn-outline-custom ml-auto" *ngIf="!update && indexPage === 0.1">
              {{ steppeurMessage.demarrerDemande | translate }}
            </button>
            <button (click)="suivant()" class="btn btn-outline-primary ml-auto" *ngIf="update && indexPage === 0.1">
              {{ steppeurMessage.boutonContinuer | translate }}
            </button>
            <button *ngIf="indexPage !== 0.1" (click)="precedent()" class="btn btn-outline-custom"
              [disabled]="indexPage<=1 || disableIfErrorInSection()" (mousedown)="noFocus($event);" (mouseup)="noFocus($event);">
              {{ steppeurMessage.boutonPrecedent | translate }}
            </button>
            <button *ngIf="!isEform && indexPage !== 0.1 && indexPage!== 0.2 && indexPage!==0.3 && indexPage!== 0.4" id="id_envoyer" (click)="validateStep(indexPage, true, false)" class="btn btn-primary ml-3">
              {{ steppeurMessage.boutonValiderStep | translate }}
            </button>
            <button *ngIf="indexPage !==0.1 && indexPage !== validationIndex && isEform" (click)="suivant();"
              (mousedown)="noFocus($event);" (mouseup)="noFocus($event);" [disabled]="disableIfErrorInSection()"
              class="btn ml-3 marge-right-23 btn-outline-custom">
              {{ steppeurMessage.boutonSuivant | translate }}
            </button>
            <button *ngIf="indexPage !==0.1 && indexPage !== validationIndex && !isEform" (click)="suivant();"
              (mousedown)="noFocus($event);" (mouseup)="noFocus($event);"
              class="btn btn-outline-custom ml-3 marge-right-36">
              {{ steppeurMessage.boutonSuivant | translate }}
            </button>
            <button *ngIf="indexPage === validationIndex && isEform" id="id_envoyer" (click)="validateStep(indexPage, true, false)" class="btn btn-primary ml-3">
              {{ steppeurMessage.boutonValiderForm | translate }}
            </button>
            <button *ngIf="indexPage === validationIndex" (click)="sendForm();" class="btn btn-primary ml-3" [disabled]="isSending">
              {{ steppeurMessage.boutonEnvoyer | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
